export const soilIonicContentStops: [number, string][] = [
  [0, '#2A7AF6'],
  [0.2, '#54C1F9'],
  [0.4, '#9FFA89'],
  [0.6, '#F3F852'],
  [0.8, '#FF7A40'],
  [1, '#FF0905'],
]
